import { parseMoneyToCents } from '@agos/shared'

/**
 * What a card payment charges, and when the e-mail-keyed discounts apply - `FRONTEND.md` §9.809, owner O154.
 *
 * The owner was sent to *Platba neúspešná* with *"Suma platby nezodpovedá objednávke"* on a basket with points and a
 * trvalá zľava, and a refresh changed nothing. The checkout sent its own preview as the amount, and `POST
 * /payments/initiate` refuses one more than 0,50 € under the order's total (§10A.264), so every rule the preview and
 * the server read differently became a refused payment.
 */

/**
 * The amount to charge, in cents: the total the server wrote for this order, or the preview when the answer carries
 * no usable total.
 *
 * The order row is what the receipt, the fiškál and the archive read, so it is the only amount that pays *this*
 * order. A missing, non-numeric or non-positive `total` falls back to the preview rather than charging nought.
 */
export function chargeCents(placed: unknown, previewCents: number): number {
  if (typeof placed !== 'object' || placed === null) return previewCents
  const total = (placed as { total?: unknown }).total
  if (typeof total !== 'number' && typeof total !== 'string') return previewCents
  if (typeof total === 'string' && total.trim() === '') return previewCents
  const cents = parseMoneyToCents(total)
  return Number.isFinite(cents) && cents > 0 ? cents : previewCents
}

/**
 * Whether the order's e-mail is the signed-in account's - the server's `ownsTheEmail`.
 *
 * Points and the trvalá zľava are keyed on the e-mail, and the server honours them only for the account's own, case
 * and surrounding spaces ignored. A guest, or an account whose e-mail is not known yet, has neither.
 */
export function identityDiscountsApply(accountEmail: string, orderEmail: string): boolean {
  const account = accountEmail.trim().toLowerCase()
  return account !== '' && account === orderEmail.trim().toLowerCase()
}
